// extracted by mini-css-extract-plugin
module.exports = {"list":"EmailDomainList_list__2LrQ3"};